import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataServiceService } from '../data-service.service';
import { Company } from '../model/Company';

@Component({
  selector: 'app-new-company',
  templateUrl: './new-company.component.html',
  styleUrls: ['./new-company.component.scss']
})
export class NewCompanyComponent implements OnInit {

  newCompany: Company = {
    companyId: '',
    userCount: 0,
    companyEmail: '',
    companyName: '',
    companyType: '',
    clientNumber: '',
    registeredAddress: '',
    registrationNumber: '',
    contractSignDate: new Date(),
    status: '',
    statusRemarks: ''
  }

  constructor(private modalService: NgbModal, private dataService: DataServiceService, private router: Router) { }

  ngOnInit(): void {
  }

  invalidName(){
    if(this.newCompany.companyName.trim() == "") return true
    else return false
  }

  invalidType(){
    if(this.newCompany.companyType.trim() == "") return true
    else return false
  }

  invalidClNum(){
    if(this.newCompany.clientNumber.trim() == "") return true
    else return false
  }

  invalidAddress(){
    if(this.newCompany.registeredAddress.trim() == "") return true
    else return false
  }

  invalidRNum(){
    if(this.newCompany.registrationNumber.trim() == "") return true
    else return false
  }

  invalidForm(){
    return this.invalidEmail() || this.invalidName() || this.invalidType() || this.invalidClNum() || this.invalidAddress() || this.invalidRNum();
  }

  invalidEmail() {
    if (
      !this.validateEmail(this.newCompany.companyEmail) ||
      this.newCompany.companyEmail.trim() == ""
    )
      return true;
    else return false;
  }

  submitForm(){
    this.newCompany.status = 'Inforce'
    this.dataService.addCompany(this.newCompany)
    .then(() => {
      const but = document.getElementById("successBtn") as HTMLButtonElement;
      but.click();
      setTimeout(() => {
        this.modalService.dismissAll()
        this.router.navigate(['/all-companies'])
      }, 3000);
    })
    .catch(() => {
      const but = document.getElementById("failBtn") as HTMLButtonElement;
      but.click();
    });
  }

  openSmallModal( smallModalContent ) {
    this.modalService.open( smallModalContent, { size : 'sm' } );
  }

  validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  openSuccessPopup(smallModalContent) {
    this.modalService.open(smallModalContent, { size: "sm" });
  }

  openFailPopup(smallModalContent2) {
    this.modalService.open(smallModalContent2, { size: "sm" });
  }
}
